'use client';

import { c as _c } from "react/compiler-runtime";
import { FC, useEffect, useState } from 'react';
import GridView from '@/components/BlogPage/PostsList/GridView';
import { BlogAuthorDto, BlogPostDto } from '@/components/BlogPage/types';
import { getBlogPosts } from '@/lib/blog';
interface Props {
  author: BlogAuthorDto;
}
const AuthorsPosts: FC<Props> = t0 => {
  const $ = _c(7);
  const {
    author
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [posts, setPosts] = useState(t1);
  let t2;
  if ($[1] !== author.id) {
    t2 = () => {
      const getPosts = async () => {
        const data = await getBlogPosts({
          params: `filters[author][id][$eq]=${author.id}`,
          populateDeepLevel: 2
        });
        setPosts(data || []);
      };
      if (author?.id) {
        getPosts();
      }
    };
    $[1] = author.id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== author) {
    t3 = [author];
    $[3] = author;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (!posts?.length) {
    return null;
  }
  let t4;
  if ($[5] !== posts) {
    t4 = <section><GridView posts={posts} /></section>;
    $[5] = posts;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default AuthorsPosts;